import React from 'react';
import Modal from '@medflex/components/stories/Modal';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { showAlertToast, showSuccessToast } from '@medflex/components/stories/Toast';
import { trackEvent } from '@medflex/utils/Tracking';
import Textarea from 'react-textarea-autosize';
import Button from '@medflex/components/stories/Button';
import { AutoResponseMessage } from '@medflex/shared-constants';
import useModal from '../hooks/useModal';
import { MODALS } from '../hooks/useIsModal';
import useAutoResponseMessage from '../hooks/useAutoResponseMessage';

const AutoResponseMessageEditModal = () => {
  const { close } = useModal();

  const { t } = useTranslation('physician');
  const { autoResponseMessage, saveAutoResponseMessage } = useAutoResponseMessage();
  const {
    control,
    handleSubmit: wrapSubmit,
    setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: { message: autoResponseMessage || AutoResponseMessage.DEFAULT },
  });

  const handleSubmit = async (data, event) => {
    const { message } = data;

    try {
      await saveAutoResponseMessage({ autoResponseMessage: message });
      showSuccessToast(t('toasts.autoResponseMessage.success.title'), null, {
        toastId: 'autoResponseMessageChangeSuccess',
      });
      trackEvent(event, { actionText: 'manage_Textblock' });
    } catch (e) {
      showAlertToast(t('toasts.autoResponseMessage.alert.title'), null, {
        toastId: 'autoResponseMessageChangeFailed',
      });
    }

    close({ modal: MODALS.autoResponseMessageEdit });
  };

  const onResetText = () => {
    setValue('message', AutoResponseMessage.DEFAULT);
  };

  return (
    <Modal
      showCloseButton
      title={t('modals.AutoResponseMessageEditModal.title')}
      onClickCloseButton={() => close({ modal: MODALS.autoResponseMessageEdit })}
    >
      <div data-component="AutoResponseMessageEditModal">
        <form onSubmit={wrapSubmit(handleSubmit)} className="flex flex-1 flex-col">
          <p className="mb-4 font-semibold">
            {t('modals.AutoResponseMessageEditModal.description')}
          </p>
          <Controller
            control={control}
            defaultValue=""
            name="message"
            render={({ onChange, value, name }) => (
              <Textarea
                className="mb-4 rounded border border-slate-500 p-3 leading-tight placeholder-slate-500 outline-none focus:border-blue-500"
                id={name}
                maxRows={10}
                minRows={3}
                name={name}
                onChange={val => onChange(val)}
                maxLength={AutoResponseMessage.MAX_LENGTH}
                value={value}
              />
            )}
            rules={{ maxLength: AutoResponseMessage.MAX_LENGTH, required: true }}
          />
          <Button className="mb-6 self-end" kind="link" onClick={onResetText}>
            {t('modals.AutoResponseMessageEditModal.reset')}
          </Button>
          <Button type="submit" className=" self-end">
            {t('modals.AutoResponseMessageEditModal.cta')}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default AutoResponseMessageEditModal;
